import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
import { SITE } from '../seo/siteMeta';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-950 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand with Logo */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_engineered-fast/artifacts/pqs8nrxs_Untitled%20design%20%281%29.png"
              alt="H.A.R.P Solutions LTD"
              className="h-24 md:h-28 w-auto object-contain"
            />
            <p className="text-gray-400 italic text-sm">
              Engineered for Reliability. Delivered Without Delay.
            </p>
            <p className="text-gray-500 text-sm">
              Always ready when you need us most.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('why-choose-us')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Why Choose Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">Handyman</li>
              <li className="text-gray-400">Air Conditioning</li>
              <li className="text-gray-400">Refrigeration</li>
              <li className="text-gray-400">Plumbing</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <a href="tel:+443301221094" className="text-gray-400 hover:text-amber-500 transition-colors font-medium">
                  +44 330 122 1094
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <a href="mailto:info@harp-solutions.co.uk" className="text-gray-400 hover:text-amber-500 transition-colors">
                  info@harp-solutions.co.uk
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div className="text-gray-400">
                  <a
                    href={SITE.mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="not-italic block hover:text-amber-500 transition-colors"
                    data-testid="footer-address-link"
                  >
                    <span className="block">H.A.R.P Solutions LTD</span>
                    <span className="block">Suite RA01</span>
                    <span className="block">195-197 Wood Street</span>
                    <span className="block">London</span>
                    <span className="block">E17 3NU</span>
                  </a>
                  <p className="text-gray-500 text-sm mt-2 leading-snug">
                    Serving London, Greater London, Essex, Kent &amp; Surrounding Areas
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} H.A.R.P Solutions LTD. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm mt-4 md:mt-0">
            Fully Certified & Insured Engineering Services
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
